import styles from "./styles.module.css";
import { Avatar, Button, Drawer, Dropdown, Layout, Menu, Modal } from "antd";
import {
  DownOutlined,
  LogoutOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { ChangeLang } from "widgets/changeLang/ChangeLangNav";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Paths } from "shared/config/paths";
import { AuthButtons } from "features/auth/ui/authButtons/AuthButtons";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "shared/store/root.store";
import { AuthSliceMethods, getAuthState } from "features/auth/model/authSlice";
import { useTranslation } from "react-i18next";
import { ReactComponent as ShapeIcon } from "widgets/mainHeader/icons/shape.svg";
import { selectApiMode } from "shared/store/configSlice";

const DrawerUserDropdown = ({ onAction }: { onAction?: () => void }) => {
  const { t } = useTranslation();
  const { secondName, name } = useSelector(getAuthState);
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();

  const handleLogoutWithAction = () => {
    Modal.confirm({
      title: t("auth.logout_confirmation_message"),
      content: t("auth.logout_confirmation_title"),
      onOk() {
        dispatch(AuthSliceMethods.logout());
        navigate("/");
        if (onAction) onAction();
      },
    });
  };

  const menu = (
    <Menu>
      <Menu.Item
        key="logout"
        icon={<LogoutOutlined style={{ color: "red" }} />}
        onClick={handleLogoutWithAction}
      >
        <span style={{ color: "red" }}>{t("auth.exit")}</span>
      </Menu.Item>
    </Menu>
  );

  const fullName = `${name || ""} ${secondName || ""}`;

  return (
    <Dropdown overlay={menu} placement="bottomRight" trigger={["click"]}>
      <div className={styles.userProfile}>
        <Avatar className={styles.avatar} size={32}>
          <UserOutlined style={{ fontSize: 32 }} />
        </Avatar>
        <div className={styles.userInfo}>
          <span className={styles.userName}>{fullName}</span>
        </div>
        <DownOutlined className={styles.downIcon} />
      </div>
    </Dropdown>
  );
};

type Props = {
  sidebarCollapsed?: boolean;
  setSidebarCollapsed?: (a: boolean) => void;
};

export const MainHeader = ({
  sidebarCollapsed,
  setSidebarCollapsed,
}: Props) => {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const apiMode = useSelector(selectApiMode);

  const hideRightSection = pathname === Paths.login;

  const showDrawer = () => setOpen(true);
  const closeDrawer = () => setOpen(false);

  return (
    <Layout.Header className={styles.header}>
      <div className={styles.modeWrapper}>
        <Button
          aria-label="Toggle sidebar"
          type="text"
          icon={<ShapeIcon width={24} height={24} stroke="#0E5A3B" />}
          onClick={() => setSidebarCollapsed!(!sidebarCollapsed)}
          style={{ fontSize: 25, width: 48, height: 48 }}
        />

        <div className={styles.mode}>
          {apiMode === "BASE" ? "Прод" : "Тестовый"}
        </div>
      </div>

      <div className={styles.burgerIcon} onClick={showDrawer}>
        <MenuOutlined />
      </div>

      <div className={styles.rightSection}>
        <ChangeLang />
        {!hideRightSection && <AuthButtons />}
      </div>

      <Drawer
        placement="right"
        onClose={closeDrawer}
        open={open}
        className={styles.mobileDrawer}
      >
        <div className={styles.mobileMenu}>
          <ChangeLang />
          <DrawerUserDropdown onAction={closeDrawer} />
        </div>
      </Drawer>
    </Layout.Header>
  );
};
